import {createAnalyticsTracker} from "../analytics-tracker.js"

// Explicit allowlist: trade actions plus separately labeled authentication observations.
// Never forward identities or shared URLs. Auth mounts are not trade engagement.
const umamiEvents = new Set([
  "trade.team_added", "trade.team_removed", "trade.player_toggled",
  "trade.pick_configured", "trade.destination_selected", "trade.edit_from_shared",
  "trade.saved", "trade.validated",
  "auth.login_started", "auth.registered_visit",
])
const safeProperties = [
  "team_count", "total_players", "total_picks", "is_valid", "error_count", "warning_count",
  "registered",
]

export default {
  mounted() {
    const tracker = createAnalyticsTracker()
    this.handleEvent("analytics:track", ({event, properties}) => {
      const meaningful = !properties?.is_admin && umamiEvents.has(event) &&
        (event !== "trade.validated" ||
          (properties?.total_players > 0 || properties?.total_picks > 0))
      const umamiData = meaningful
        ? Object.fromEntries(safeProperties.filter(key =>
          typeof properties?.[key] === "boolean" ||
          (typeof properties?.[key] === "number" && Number.isFinite(properties[key]))
        ).map(key => [key, properties[key]]))
        : null
      tracker.track(event, properties, umamiData)
    })
    this.handleEvent("analytics:identify", ({user_id, traits}) => {
      if (window.jitsu) window.jitsu("id", {id: user_id, ...traits})
    })
    this.handleEvent("analytics:page", ({properties}) => {
      if (window.jitsu) window.jitsu("page", properties)
    })
  }
}
